import { useMemo } from 'react';
import dict from '../i18n/howItWorks.json';
import { createT } from '../i18n/createT';

/** Traducteur de /how-it-works. Repli : langue → fr → chemin brut. */
export function useHowItWorksT(language) {
  return useMemo(() => createT(dict, language), [language]);
}

export default useHowItWorksT;
